// extracted by mini-css-extract-plugin
module.exports = {"card":"SkillsCard_card__tjBFa","body":"SkillsCard_body__2QQh9","details":"SkillsCard_details__2VQfl","cardimg":"SkillsCard_cardimg__sS_P4"};